import React, { Component } from 'react'
import Link from 'gatsby-link'

import { NavigationDrawer } from 'react-md'
import getNavItems from './NavItems'

import './Navigation.css'

class Navigation extends Component {

  constructor() {
    super()

    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    const navbar = document.querySelector('.navbar');
    const bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    if (bodyScrollTop >= 20) {
      navbar.classList.add('nav-colored');
      navbar.classList.remove('nav-transparent');
    } else {
      navbar.classList.add('nav-transparent');
      navbar.classList.remove('nav-colored');
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  render() {
    const { children } = this.props;
    return (
      <NavigationDrawer
        toolbarClassName="navbar nav-transparent"
        drawerTitle="OLLIE"
        toolbarTitle="OLLIE"
        contentClassName="main-content"
        navItems={getNavItems()}
        mobileDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
        tabletDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}
        desktopDrawerType={NavigationDrawer.DrawerTypes.TEMPORARY}>
        <div className="main-container">{children}</div>
      </NavigationDrawer>
    )
  }
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/components/Navigation.js